import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PatientPreference {
  patientPreferenceId: string;
  patientProfileId: number;
  preferenceIdentifier: string;
  categoryId: number;
  categoryCode: string;
  categoryDisplayName: string;
  isActive: boolean;
}

interface PatientPreferencesState {
  patientPreferences: PatientPreference[];
}

// Payload will only include categoryCode and preferenceIdentifier
interface UpdatePreferencePayload {
  categoryCode: string;
  preferenceIdentifier: string;
}

const initialState: PatientPreferencesState = {
  patientPreferences: [],
};

const patientPreferencesSlice = createSlice({
  name: "patientPreferences",
  initialState,
  reducers: {
    setPatientPreferences: (
      state,
      action: PayloadAction<PatientPreference[]>
    ) => {
      state.patientPreferences = action.payload;
    },
    updatePatientPreference: (
      state,
      action: PayloadAction<UpdatePreferencePayload>
    ) => {
      const { categoryCode, preferenceIdentifier } = action.payload;
      const index = state.patientPreferences.findIndex(
        (pref) => pref.categoryCode === categoryCode
      );
      if (index !== -1) {
        state.patientPreferences[index].preferenceIdentifier = preferenceIdentifier;
      }
    },
  },
});

export const { setPatientPreferences, updatePatientPreference } =
  patientPreferencesSlice.actions;

export default patientPreferencesSlice.reducer;
